module.exports = __webpack_public_path__ + "static/ex2-4014df37b0087a33594e0488b44d6a71.png";